import TripNewForm from "../../Components/Trips/TripNewForm";
import "../../Components/Style/Trips/TripNewForm.css";

const TripsNew = () => {
  return (
    <div className="trip-new-table">
      <TripNewForm />
    </div>
  );
};

export default TripsNew;
